import * as React from "react";
import { Text } from "@radix-ui/themes";
import { MarginProps } from "@radix-ui/themes/props";
import clsx from "clsx";
import { namespaceClassNames } from "./utils.js";

type TextProps = React.ComponentPropsWithoutRef<typeof Text>;

type MarkerOwnProps = {
  color?: "gray" | "purple" | "blue" | "green" | "yellow" | "red";
  highContrast?: boolean;
  size?: TextProps["size"];
};

interface MarkerProps
  extends
    Omit<React.ComponentPropsWithRef<"span">, "color">,
    MarkerOwnProps,
    MarginProps {}

export const Marker = React.forwardRef<HTMLSpanElement, MarkerProps>(
  function Marker(
    { children, className, highContrast, ...props },
    forwardedRef,
  ) {
    return (
      <Text
        ref={forwardedRef}
        className={clsx(className, namespaceClassNames("marker"))}
        {...props}
      >
        <span className={namespaceClassNames("marker-circle")}>
          <span className={namespaceClassNames("marker-content")}>
            {children}
          </span>
        </span>
      </Text>
    );
  },
);
